// components/AssetTokenSync.tsx

import { useAssetTokenSync } from "@/features/auth/api/auth-api";

export function AssetTokenSync() {
  useAssetTokenSync();
  return null;
}
